<div class="flex space-between trip-final-info">
  <span class="route-info">Trip Timeline</span>
  <span class="trip-status" [ngClass]="{
      'trip-status-ongoing': tripDetails.status === 'Started',
      'trip-status-ended': tripDetails.status === 'Ended',
      'trip-status-hidden' : !tripDetails.status
    }" misToolTip [text]=" tripDetails.status === 'Started' ? 'Planned Trip Completion':''">
    {{getTripCurrentStatus()}}
  </span>
</div>

<div class="timeline-container">

  <div *ngIf="tripDetails.direction === 'OUT'"
    [ngClass]="{
      'first-logout-in-progress': firstLogoutInProgress,
      'timeline-item': true,
      'destination': true,
      'flex': true,
      'space-between': true
    }" class="flex space-between timeline-item destination"
    style="align-items: normal; height: 58px; border-left: 6px solid #638FE7 !important;">

    <div class="flex-column gap-8 ml-2" style="margin-top: -10px;">
      <span class="planned-address">{{ tripDetails?.plannedStartLocation?.address }}</span>
      <span class="planned-time flex gap-4">
        <img [src]="IMAGE_CONSTANTS.PLANNED_TIME_ICON" width="14" height="14" alt="Timeline Icon" />
        <span misToolTip [text]="'Planned Start Time'">
          {{ getEmployeeTimings(tripDetails.plannedStartTime) }}
        </span>
      </span>
    </div>

    <div style="margin-top: -10px;" *ngIf="tripDetails['status']=== 'Ended'">
      <div class="actualPickupTime" misToolTip [text]="'Trip End Time'">
        {{ getEmployeeTimings(tripDetails.actualEndTime) }}
        <span class="delay-time" [ngStyle]="{
            'color': isPositive(getFinalTimeDifference(tripDetails['actualEndTime'], tripDetails['plannedEndTime'])) ? redColor : greenColor,
            'display': !getFinalTimeDifference(tripDetails['actualEndTime'], tripDetails['plannedEndTime']) ? 'none' : 'normal'
          }">
          ({{ getFinalTimeDifference(tripDetails['actualEndTime'], tripDetails['plannedEndTime']) > 0 ? '+' : '' }}
          {{ getFinalTimeDifference(tripDetails['actualEndTime'], tripDetails['plannedEndTime']) }} mins)
        </span>
      </div>
    </div>

    <div class="svg-container" style="left: -15px; top: 3px;">
      <img [src]="IMAGE_CONSTANTS.SOURCE_ICON" width="24" height="24" alt="Source Icon" />
    </div>

    <div *ngIf="firstLogoutInProgress" class="show-svg-container" style="top: 70%;">
      <img [src]="IMAGE_CONSTANTS.CAR_ICON" width="42" height="42" alt="Car Icon" />
    </div>

  </div>

  <div *ngFor="let emp of tripDetails.employees; let i = index; let last=last; let first=first;"
    [ngClass]="getStatusClass(emp, i)" class="timeline-item" [ngStyle]="{
    'border-left': (last && tripDetails.direction === 'OUT') ? '6px solid white' : ''
  }">
    <div class="timeline-content flex-column gap-8" [ngStyle]="{
      'border-top': (first && tripDetails.direction === 'OUT') ? '1px solid #e0e0e0' : '',
      'padding-top': (first && tripDetails.direction === 'OUT') ? '' : ''
    }">
      <div class="flex space-between">
        <div class="flex gap-4 ml-2">
          <div class="employee-details flex gap-4">
            <span misToolTip [text]="emp.escort ? '' : emp.name" class="employee-name" [position]="'right'">
              {{ emp.employeeId }}
            </span>
            <img *ngIf="emp.escort" misToolTip [text]="emp.name" [position]="'right'" [src]="IMAGE_CONSTANTS.ESCORT_ICON"
              width="16" height="16" alt="Escort icon" />
          </div>
          <img [src]="IMAGE_CONSTANTS.DOT_SEPARATOR" width="24" height="24" alt="separator icon" />
          <div class="gender" misToolTip [text]="emp.gender">
            <img *ngIf="emp.gender !== 'Male'" [src]="IMAGE_CONSTANTS.FEMALE_ICON" width="16" height="16"
              alt="Female Icon" />
            <img *ngIf="emp.gender === 'Male'" [src]="IMAGE_CONSTANTS.MALE_ICON" width="16" height="16"
              alt="Male Icon" />
          </div>
          <ng-container *ngIf="emp.specialNeedType">
            <img [src]="IMAGE_CONSTANTS.DOT_SEPARATOR" width="24" height="24" alt="separator icon" />
            <div class="specialNeedType" misToolTip [text]="emp.specialNeedType">
              <img [src]="IMAGE_CONSTANTS.SPECIAL_NEED_TYPE_ICON" width="16" height="16"
              alt="Special Need Type Icon" />
            </div>
          </ng-container>
          <img [src]="IMAGE_CONSTANTS.DOT_SEPARATOR" width="24" height="24" alt="separator icon" />
          <div class="boarding-status">
            <span class="boarded" [ngStyle]="{
              color: getBoardingStatus(emp) === 'NO SHOW' ? redColor : ''
            }">{{getBoardingStatus(emp)}}</span>
          </div>
          <div class="attendance-action" *ngIf="isAllowSignoutEmployeesOnTripView() && !emp?.actualPickupTime && !emp?.noShow && tripDetails.status !== 'Ended'">
            <img [src]="IMAGE_CONSTANTS.SIGN_IN_ICON" width="16" height="16" alt="Sign In Icon"
            misToolTip [text]="'Click on the icon to sign in the employee'" [position]="'right'"
            (click)="updateEmployeeStatus(emp,AttendanceAction.SIGNIN)"
            class="cursor-pointer"
            />
          </div>
          <div class="attendance-action" *ngIf="isAllowSignoutEmployeesOnTripView() && isSignedIn(emp)">
            <img [src]="IMAGE_CONSTANTS.SIGN_OUT_ICON" width="16" height="16" alt="Sign Out Icon"
            misToolTip [text]="'Click on the icon to sign out the employee'" [position]="'right'"
            (click)="updateEmployeeStatus(emp,AttendanceAction.SIGNOUT)"
            class="cursor-pointer"
            />
          </div>
        </div>
        <div class="actualPickupTime" misToolTip [text]="getDestinationTooltipMessage(emp)">
          {{ getDestinationReachTime(emp) }}
          <span class="delay-time" [ngStyle]="{
            'color': isPositive(getTimeDifference(emp)) ? redColor : greenColor,
            'display': !getTimeDifference(emp) ? 'none' : 'normal'
          }">
            ({{ getTimeDifference(emp) > 0 ? '+' : ''}}{{getTimeDifference(emp)}} mins)
          </span>
        </div>
      </div>
      <div class="flex gap-4">
        <span misToolTip [text]="'Planned Sign-in Time'" [position]="'bottom'" class="pickup-details">
          <img [src]="IMAGE_CONSTANTS.PLANNED_TIME_ICON" width="14" height="14" alt="Timeline Icon" />
          <span>
            {{ getEmployeeTimings(emp.plannedPickupTime) }}
          </span>
        </span>
        <span class="pickup-details" misToolTip [text]="'Driver Reporting Time'" [position]="'bottom'" >
          <img  [src]="IMAGE_CONSTANTS.DRIVER_ARRIVAL_ICON" width="14" height="14" alt="Timeline Icon" />
          <span>
            {{ getEmployeeTimings(emp.driverReportingTime) }}
          </span>
          <!-- <span class="relative mt-4" 
          (mouseenter)="showTooltip(i)" 
          (mouseleave)="hideTooltip(i)">
          <img class="h-20 w-20" [src]="IMAGE_CONSTANTS.BLUE_INFO_ICON" width="14" height="14" alt="Timeline Icon" />
          <div class="custom-tooltip" *ngIf="hoveredTooltipIndex === i">
            <img class="tooltip-close" [src]="IMAGE_CONSTANTS.CANCEL_ICON"/>
            <div class="tooltip-content">{{ tooltip_text }}</div>
            <div class="tooltip-content anchor-text">
              <span>
                <a class="a-tag" target="_blank" href="https://help-moveinsync.freshdesk.com/support/solutions/articles/1070000086489"> {{ 'Learn More' }}</a>
              </span>
              <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M10.3386 8.2304H9.974C9.92075 8.2304 9.87705 8.24746 9.84305 8.28174C9.80877 8.31582 9.79171 8.3595 9.79171 8.41269V10.2356C9.79171 10.4863 9.70253 10.7008 9.52405 10.8793C9.34557 11.0578 9.13096 11.147 8.88029 11.147H4.1406C3.88996 11.147 3.67536 11.0578 3.49685 10.8793C3.31837 10.7008 3.22914 10.4863 3.22914 10.2356V5.49599C3.22914 5.24534 3.31835 5.03083 3.49685 4.85233C3.67536 4.67381 3.88996 4.5846 4.1406 4.5846H8.15101C8.20426 4.5846 8.24796 4.56747 8.2821 4.53333C8.31624 4.49915 8.3333 4.45551 8.3333 4.4023V4.03766C8.3333 3.98454 8.31624 3.94083 8.2821 3.90671C8.24796 3.87253 8.20426 3.85547 8.15101 3.85547H4.1406C3.68871 3.85547 3.30226 4.01593 2.9813 4.33683C2.66046 4.65771 2.5 5.04416 2.5 5.49605V10.2357C2.5 10.6876 2.66046 11.0741 2.98132 11.3948C3.30228 11.7158 3.68873 11.8763 4.14062 11.8763H8.88029C9.33216 11.8763 9.71865 11.7158 10.0396 11.3948C10.3605 11.0741 10.521 10.6876 10.521 10.2357V8.41283C10.521 8.35958 10.5039 8.31588 10.4696 8.28174C10.4354 8.24746 10.3917 8.2304 10.3386 8.2304Z" fill="#0937B2"/>
                <path d="M12.6003 3.23322C12.5281 3.16105 12.4426 3.125 12.3439 3.125H9.42725C9.32852 3.125 9.24303 3.16105 9.17092 3.23322C9.09875 3.30535 9.06261 3.39081 9.06261 3.48956C9.06261 3.5883 9.09875 3.67378 9.17092 3.74595L10.1735 4.74854L6.45933 8.46278C6.4213 8.50075 6.40234 8.54445 6.40234 8.59373C6.40234 8.64319 6.42136 8.68687 6.45933 8.72484L7.10875 9.37419C7.14672 9.41216 7.19042 9.43109 7.23978 9.43109C7.28915 9.43109 7.33286 9.41218 7.37081 9.37419L11.085 5.66001L12.0876 6.6626C12.1598 6.73477 12.2452 6.77086 12.344 6.77086C12.4427 6.77086 12.5282 6.73477 12.6004 6.6626C12.6726 6.59045 12.7086 6.50501 12.7086 6.40626V3.48956C12.7086 3.39075 12.6724 3.30535 12.6003 3.23322Z" fill="#0937B2"/>
                </svg>
            </div>
          </div>
        </span> -->
        
        </span>
        <span *ngIf="!emp?.noShow" misToolTip [text]="'Actual Sign-In Time'" [position]="'bottom'" class="pickup-details">
          <img [src]="IMAGE_CONSTANTS.ACTUAL_TIME_ICON" width="14" height="14" alt="Timeline Icon" />
          <span>
            {{ getEmployeeTimings(emp.actualPickupTime) }}
          </span>
        </span>

        <span *ngIf="emp?.noShow" misToolTip [text]="'No Show Marked At'" [position]="'bottom'" class="pickup-details">
          <img [src]="IMAGE_CONSTANTS.NO_SHOW_ICON" width="14" height="14" alt="Timeline Icon" />
          <span>
            {{ getEmployeeTimings(emp.noShowTimeStamp) }}
          </span>
        </span>
        
      </div>
      <div class="flex space-between">
        <div class="flex gap-4">
          <img [src]="IMAGE_CONSTANTS.LOCATION_ICON" width="16" height="16" alt="Location Icon" />
          <span class="location" misToolTip [text]="getDropLocation(tripDetails.direction, emp)" [position]="'right'">
            {{getDropLocation(tripDetails.direction, emp)}}</span>
        </div>
        <img [src]="IMAGE_CONSTANTS.INFO_ICON" width="16" height="16" misToolTip [text]="'Employee Details'" alt="Info Icon"
          class="cursor-pointer" (click)="openEmployeeDetails(emp)" />
      </div>
    </div>
    <div class="svg-container">
      <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g filter="url(#filter0_d_7369_161068)">
          <circle cx="16" cy="14" r="12" fill="white" />
          <circle cx="16" cy="14" r="11.25" stroke="#0937B2" stroke-width="1.5" />
        </g>
        <circle cx="16" cy="14" r="9" fill="#CBDDFB" />
        <text x="16" y="18" text-anchor="middle" fill="#0937B2" font-size="12" font-family="Arial">{{ i + 1 }}</text>
        <defs>
          <filter id="filter0_d_7369_161068" x="0" y="0" width="32" height="32" filterUnits="userSpaceOnUse"
            color-interpolation-filters="sRGB">
            <feFlood flood-opacity="0" result="BackgroundImageFix" />
            <feColorMatrix in="SourceAlpha" type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
            <feOffset dy="2" />
            <feGaussianBlur stdDeviation="2" />
            <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0" />
            <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_7369_161068" />
            <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_7369_161068" result="shape" />
          </filter>
        </defs>
      </svg>
    </div>
    <div *ngIf="shouldShowCarIcon(getTripStatus(emp, i))" class="show-svg-container">
      <img [src]="IMAGE_CONSTANTS.CAR_ICON" width="42" height="42" alt="Car Icon" />
    </div>
    
  </div>

  <div *ngIf="tripDetails.direction === 'IN'"
    class="timeline-item destination flex space-between"
    style="align-items: normal;">

    <div class="flex-column gap-8 ml-2" style="margin-top: -11px;">
      <span class="planned-address">{{ tripDetails?.plannedEndLocation?.address }}</span>
      <span class="planned-time flex gap-4">
        <img [src]="IMAGE_CONSTANTS.PLANNED_TIME_ICON" width="14" height="14" alt="Timeline Icon" />
        <span misToolTip [text]="'Planned End Time'">
          {{ getEmployeeTimings(tripDetails.plannedEndTime) }}
        </span>
      </span>
    </div>

    <div style="margin-top: -10px;" *ngIf="tripDetails['status']=== 'Ended'">
      <div class="actualPickupTime" misToolTip [text]="'Trip End Time'">
        {{ getEmployeeTimings(tripDetails.actualEndTime) }}
        <span class="delay-time" [ngStyle]="{
            'color': isPositive(getFinalTimeDifference(tripDetails['actualEndTime'], tripDetails['plannedEndTime'])) ? redColor : greenColor,
            'display': !getFinalTimeDifference(tripDetails['actualEndTime'], tripDetails['plannedEndTime']) ? 'none' : 'normal'
          }">
          ({{ getFinalTimeDifference(tripDetails['actualEndTime'], tripDetails['plannedEndTime']) > 0 ? '+' : '' }}
          {{ getFinalTimeDifference(tripDetails['actualEndTime'], tripDetails['plannedEndTime']) }} mins)
        </span>
      </div>
    </div>

    <div class="svg-container" style="top: -2px;">
      <img [src]="IMAGE_CONSTANTS.DESTINATION_ICON" width="24" height="24" alt="Drop Icon" />
    </div>

  </div>
</div>

<div class="overlay" *ngIf="employeeInfo">
  <div class="popup">
    <h2 style="font-size: 20px;font-weight:bold;border-bottom:1px solid lightgray">Employee Details</h2>
    <a class="close" (click)="employeeInfo=false">&times;</a>
    <div class="content d-flex flex-dir-rol gap-8">
      <span style="font-size: 20px;">{{employeeDetailsInfo?.name}}</span>
      <img *ngIf="!!employeeDetailsInfo?.phoneNumber" [src]="IMAGE_CONSTANTS.LINE_SVG" style="height: 20px;" alt="">
      <span *ngIf="!!employeeDetailsInfo?.phoneNumber" style="font-size: 20px;">
        <img [src]="IMAGE_CONSTANTS.CALL_ICON" style="margin-right: 14px" />  {{ 
          dataService.isVendorRole() ?
          (dataService.ETS_PROPERTIES$ | async)?.['TEXT_SHOWN_FOR_HIDDEN_INFO_TO_VENDORS'] :
          employeeDetailsInfo?.phoneNumber
          }}</span>
    </div>
  </div>
</div>
